import { MibeModel } from './mibemodel.model';

export class Theme implements MibeModel {
  id: number;
  name: string;

  /**
   * Create a Theme.
   * @param {any} json - The JSON object with which to construct our Theme.
   */
  constructor(json:any) {
    this.loadWithJSON(json);
  }
  /**
   * Load a Theme.
   * @param {any} json - The JSON object with which to load our Theme.
   */
  loadWithJSON(json: any) {
    if (!json) {
      return;
    }
    this.id = json.id;
    this.name = json.name && json.name?.replace(/ {2,}/g, ' ');
  }
  /**
   * Returns a JSON representation of our Theme
   * @return {any} - The JSON representation of our Theme
   */
  toJSON() {
    var json: any = {
      'id': this.id,
      'name': this.name,
    };
    return json;
  }
}
